export class JobProgressStepEta {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "etaLowerSeconds",
            "baseName": "etaLowerSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "etaUpperSeconds",
            "baseName": "etaUpperSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "computedAt",
            "baseName": "computedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "JobEtaSource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepEta.attributeTypeMap;
    }
    constructor() {
    }
}
